import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import CustomInput from '../../atoms/Input';
import Button from '../../atoms/Button';
import { getUserOnLogin } from "../../../service/auth";
import { appActions, authActions, enamelPaintingFormActions, workOrderFormActions } from "../../../store/slices";
import { UtilityFunctions } from "../../../utils";
import { EnamelPaintingService, WorkOrderService } from "../../../service";

export default function LoginForm({header, setLoginMode}) {
    const [disabled, setDisabled] = useState()
    const [values, setValues] = useState({
        email: '',
        companyCode: '',
        password: ''
    })
    const [errors, setErrors] = useState({
        email: '',
        companyCode: '',
        password: ''
    })

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.app.isLoading);
    
    const { email, companyCode, password } = values;

    const handleInput = (e) => {
        const { name, value } = e.target;

        setErrors((prevState) => {
            return {
                ...prevState,
                [name]: ''
            }
        })

        setValues({
            ...values,
            [name]: value,
        });
    };

    useEffect(() => {
        if (isLoading || !email || !password || !companyCode) {
            setDisabled(true);
        } else if (!isLoading && email && password && companyCode) {
            setDisabled(false);
        }
    }, [isLoading, email, password, companyCode]);
            
    const handleLogin = async (e) => {
        e.preventDefault();

        const validatedForm = UtilityFunctions.validateForm('login', errors, values);

        if (validatedForm.error) {
            setErrors(validatedForm.errors);
            return;
        }

        try {
            dispatch(appActions.setLoading(true));
            const data = await getUserOnLogin(email, password);

            const workOrderCounter = await WorkOrderService.getWorkOrderCounter();
            dispatch(workOrderFormActions.setWorkOrderCounter(workOrderCounter));

            const enamelPaintingCounter = await EnamelPaintingService.getEnamelPaintingCounter();
            dispatch(enamelPaintingFormActions.setEnamelPaintingCounter(enamelPaintingCounter));

            if (data) {
                const { token, userInfo } = data;
                dispatch(
                    authActions.setIsLoggedIn({
                        isLoggedIn: true,
                        token,
                        user: userInfo.data(),
                    }),
                );
                const user = userInfo.data();
                dispatch(workOrderFormActions.confirm(user))
                dispatch(enamelPaintingFormActions.confirm(user))
                navigate('/factory');
            }
        } catch (error) {
            console.log(`Error occured: ${error}`);
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };

    return (
        <div className='home-page-form-container'>
            <h2>{header}</h2>
            <Form className='flex-form-column'>
                <CustomInput
                    id={'login-email'}
                    name={'email'}
                    value={email}
                    label={'E-posta Adresi'}
                    placeholder={'E-posta giriniz'}
                    onChange={handleInput}
                    error={errors.email}
                />
                <CustomInput
                    id={'login-companyCode'}
                    name={'companyCode'}
                    value={companyCode}
                    label={'Şirket Kodu'}
                    placeholder={'Kod giriniz'}
                    onChange={handleInput}
                    error={errors.companyCode}
                />
                <CustomInput
                    id={'login-password'}
                    name={'password'}
                    value={password}
                    label={'Şifre'}
                    placeholder={'Şifre giriniz'}
                    isPassword
                    onChange={handleInput}
                    error={errors.password}
                />
                <Button
                    title={'Giriş Yap'}
                    disabled={disabled}
                    onClick={handleLogin}
                    async
                    loading={isLoading}
                    type='submit'
                />
            </Form>
            <p className='sign-up-redirect'>
                <span> Henüz hesabınız yok mu? </span>
                <span className='redirect-link' onClick={() => setLoginMode(false)}>
                    Kayıt Ol
                </span>
            </p>
        </div>
    );
}
